module.exports = __webpack_public_path__ + "media/images/emblems/Urnaesch_Wappen-c2a0654a63f2841d03de05c1e1f0f898.png";